var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-07"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M5.95271 6.5848H13.9847M5.40459 2.03125V3.39748M14.4274 2.03125V3.39731M17.0837 5.89731L17.0837 15.4687C17.0837 16.8495 15.9644 17.9687 14.5837 17.9687H5.41699C4.03628 17.9687 2.91699 16.8495 2.91699 15.4688V5.89731C2.91699 4.5166 4.03628 3.39731 5.41699 3.39731H14.5837C15.9644 3.39731 17.0837 4.5166 17.0837 5.89731Z",
    stroke: "#8F9BBA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c86a8d0afb143207a8d9afdcfa3eafad.svg";
export { ForwardRef as ReactComponent };